import React, { PureComponent } from 'react'
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators'
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoyListRepeat from 'components/commons/CupoyListRepeat';
import TimeFormat from 'components/commons/TimeFormat';
import Recaptcha from "react-grecaptcha";
import GLOBAL from 'nonnglobal';

const Container = GlobalStyle.BasicBlock.extend`
`
const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
  padding-left: 20px;
  height: 65px;
  line-height: 65px;
  border-bottom: 1px solid #D9D9D9;
`;
const CommentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;

  &:not(:last-child) {
    border-bottom: solid 1px #D9D9D9;
  }
`

const Flex = styled.div`
  display: flex;
`
const QuestionFlex = Flex.extend`
  margin-bottom: 10px;
`;

const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 25px;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  color: #FFF;
  font-weight: bold;
  font-size: 16px;
  margin-right: 10px;
  background-color: ${props => props.question? Colors.MAIN_COLOR : '#4A90E2'};
`

const Text = styled.div`
  font-size: 14px;
  color: ${props => props.color? props.color:'#4a4a4a'};
`
const Name = Text.extend`
  margin-right: 4px;
`;

const CommentBlock = styled.div`
  padding: 30px 20px;
  border-bottom: solid 1px #D9D9D9;
`

const Title = styled.div`
  font-size: 16px;
  color: #4a4a4a;
  font-weight: bold;
  margin-bottom: 16px;
`

const Textarea = styled.textarea`
  height: 60px;
  width: 913px;
  font-size: 14px;
  color: #9B9B9B;
  margin-right: 10px;
  margin-top: 10px;
`

const SubmitButton = styled.div`
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  background-color: ${({ disable }) => disable ? '#9B9B9B' : Colors.MAIN_COLOR};
  transition: background-color .2s ease-in-out;
`;

const Comment = ({
  style,
  memberid = '',
  createtime,
  msgcontent = '',
  replier = '',
  replycontent = '',
  replytime,
}) => {

  const hasReply = !!replier;

  return (
    <CommentContainer style={style}>
      <div>
        {
          hasReply ?
          <React.Fragment>
            <QuestionFlex>
              <Item question>Q</Item>
              <Name>{memberid.trim()}：</Name>
              <Text>{msgcontent.trim()}</Text>
            </QuestionFlex>
            <Flex>
              <Item>A</Item>
              <Name>{replier.trim()}：</Name>
              <Text>{replycontent.trim()}</Text>
            </Flex>
          </React.Fragment>
          :
          <React.Fragment>
            <Name>留言者：{memberid.trim()}</Name>
            <Text color={Colors.MAIN_COLOR}>感謝您的留言，我們將儘快給您回覆！</Text>
          </React.Fragment>
        }
      </div>
      <Text color={'#9B9B9B'}>
        <TimeFormat
          time={hasReply ? replytime : createtime}
          format='timeString'
        />
      </Text>
    </CommentContainer>
  )
}

class CommentBoard extends PureComponent {

  constructor(props) {

    super(props);

    const routerState = CupoyRouter.getCurrent();
    const { params } = routerState;

    const {
      gameid,
      viprovid,
      serverid,
    } = params;

    this.state = {
      comment: '',
      // gender: 'male',
      recaptchaResponse: '',
      addCommenting: false,
      isCommentError: false,

      viprovid,
      gameid,
      gameserverid: serverid,
      errorMap: {},
    };

    // this.swichGenderToMale = this.swichGender.bind(this, 'male');
    // this.swichGenderToFemale = this.swichGender.bind(this, 'female');
  }

  componentDidMount() {

    this.listVprovMsgContents({ refresh: true });
  }

  listVprovMsgContents = ({ refresh = false } = {}) => {

    const {    
      viprovid,
    } = this.state;

    const {
      isLoading,
      msgIdsByVprovIds: msgIdsByVprovIdsCache,
    } = this.props;

    const msgIdsByVprovIds = msgIdsByVprovIdsCache[viprovid] || [];
    const nextStart = msgIdsByVprovIds.length;

    if (isLoading) return;

    this.props.guestbookActions.listVprovMsgContents({
      viprovid,
      start: !refresh ? nextStart : 0,
      refresh,
    }).then(({ resultSize = 0 } = {} ) => {
      if((resultSize === 0) && (msgIdsByVprovIds.length === 0))
        this.setState({ isEmpty: true });
    });
  }

  // swichGender = gender =>{
  //   this.setState({
  //     gender,
  //   });
  // }
  
  handleCommnet = event => {
    this.setState({
      comment: event.target.value,
    });
  }

  // ------------------------------
  // google callback
  // ------------------------------
  recaptchaVerifyCallback = response => {

    this.setState({
      recaptchaResponse: response,
    });
  }

  // ------------------------------
  // google expiredCallback
  // ------------------------------
  recaptchaExpiredCallback = () => {
    this.props.webActions.openAlertDialog({
      title: '安全認證已過期',
    });
  }

  addComment = () => {

    const { memberinfo, haslogin } = this.props;

    if(!haslogin) {
      this.props.webActions.needLogin();
      return;
    }

    const {
      comment,
      recaptchaResponse,
      addCommenting,
    } = this.state;
    
    const { sex } = memberinfo;

    if (addCommenting) // 避免重複觸發
        return;

    let error = false, errorMap = {}, errorMsg = '';

    if(!comment.trim()) {
        error = true;
        errorMap['comment'] = true;
        errorMsg += '請輸入留言\n';
    }

    if(!recaptchaResponse){
        error = true;
        errorMsg += '請勾選『我不是機器人』\n';
    }
    
    if(error){

      this.setState({ errorMap }, () => {
        this.props.webActions.openAlertDialog({
          title: '錯誤訊息',
          description: errorMsg,
        });
      });

    } else {
      const {
        comment,
        recaptchaResponse,
        gameid,
        gameserverid,
        viprovid,
      } = this.state;

      this.setState({
          addCommenting: true,
          errorMap: {},
      }, () => {
        this.props.guestbookActions.addVprovMsgContent({
          'passcode': recaptchaResponse,
          'viprovid': viprovid,
          'gameid': gameid,
          'gameserverid': gameserverid,
          'sex': sex,
          'msgcontent': comment,
        }).then(() => {
          this.setState({
            addCommenting: false,
            comment: '',
            recaptchaResponse: '',
          }, () => {
            window.grecaptcha.reset();
            this.listVprovMsgContents({ refresh: true });
          });
        }, (error) => {

          let errorMsg = '發生無法預期的錯誤';
          let errorDescription = '';

          if(error && error.code) {
            switch(error.code) {
              case 'error.privilege.noLogin':
                return;
              default:
                errorMsg = error.message;
                break;
            }
          }
          this.props.webActions.openAlertDialog({
            title: errorMsg,
            description: errorDescription,
          });
          this.setState({
            addCommenting: false,
            comment: '',
            recaptchaResponse: '',
          }, () => {
            window.grecaptcha.reset();
          });
        });
      });
    }
}
  
  render() {

    const {
      viprovid,
      comment,
      recaptchaResponse,
    } = this.state;

    const {
      msgIdsByVprovIds: msgIdsByVprovIdsCache,
    } = this.props;

    const msgIdsByVprovIds = msgIdsByVprovIdsCache[viprovid] || [];

    return (
      <Container>
        <Header>留言板</Header>
        <CommentBlock>
          <Title>我要留言</Title>
          <Recaptcha
            sitekey={GLOBAL.grecaptcha_key}
            callback={this.recaptchaVerifyCallback}
            expiredCallback={this.recaptchaExpiredCallback}
            locale="zh-TW"
            className="g-recaptcha"
            style={{
              transform: 'scale(0.9)',
              WebkitTransform: 'scale(0.9)',
              transformOrigin: '0 0',
              WebkitTransformOrigin: '0 0',
            }}
        />
          <Flex>
            <Textarea
              placeholder="9199提醒您：網路匿名發言仍須負相關法律責任，請勿發表誹謗等違法言論！"
              value={comment}
              onChange={this.handleCommnet}
            />
            <SubmitButton
              onClick={this.addComment}
              disable={!recaptchaResponse || !comment}
            >
              送出
            </SubmitButton>
          </Flex>
        </CommentBlock>
        <CupoyListRepeat
          rowRenderer={this.rowRenderer}
          listId={this.constructor.name}
          items={msgIdsByVprovIds}
          isLoading={this.props.isLoading}
          useWindowScroll
          restoreWindowScroll
          loadMoreRows={this.listVprovMsgContents}
        />
        {
          this.state.isEmpty ?
          <GlobalStyle.ErrorContainer>
              <GlobalStyle.ErrorContainerTitle>
                  沒有留言
              </GlobalStyle.ErrorContainerTitle>
              <GlobalStyle.ErrorContainerDesription>
                  當前沒有任何留言紀錄
              </GlobalStyle.ErrorContainerDesription>
          </GlobalStyle.ErrorContainer>
          :
          null
        }
        {this.props.isLoading ?
            <GlobalStyle.LoadingContainer>
                <GlobalStyle.Spin />
            </GlobalStyle.LoadingContainer>
            :
            null
        }
      </Container>
    )
  }

  rowRenderer = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style, // Style object to be applied to row (to position it),
    parent,
    measure,
    columnIndex,
    updateRowSize,
    measureCache,
    listWidth,
  }) => {

    const {
      viprovid
    } = this.state;

    const {
      msgIdsByVprovIds: msgIdsByVprovIdsCache,
      msgMap,
    } = this.props;

    const msgIdsByVprovIds = msgIdsByVprovIdsCache[viprovid] || [];
    const msgId = msgIdsByVprovIds[index];
    const msg = msgMap[msgId];

    const {
      memberid,
      createtime,
      msgcontent,
      replier,
      replycontent,
      replytime,
    } = msg;

    return (
      <Comment
        style={style}
        memberid={memberid}
        createtime={createtime}
        msgcontent={msgcontent}
        replier={replier}
        replycontent={replycontent}
        replytime={replytime}
      />
    );
  }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    haslogin: state.member.haslogin,
    memberinfo: state.member.memberinfo,
    sellerMap: state.vitem.sellerMap,
    msgIdsByVprovIds: state.guestbook.msgIdsByVprovIds,
    msgMap: state.guestbook.msgMap,
    isLoading: state.guestbook.isloading,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
      webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
      guestbookActions: bindActionCreators(actionCreators.guestbookActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(CommentBoard);